import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { TextField, Button } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

// material-ui
import Box from "@mui/material/Box";
import { Get_Schools_Fuzzy_Search } from "../../api/Get_Schools_Fuzzy_Search";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function SearchBar({ setSchools }) {
  const { logout } = StaffuseAuth();

  //Table Search
  const [searchName, setSearchName] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [searchPD, setSearchPD] = useState("");
  const [searchPS, setsearchPS] = useState("");
  const [searchLimit, setSearchLimit] = useState(100);
  const [searchCharity, setsearchCharity] = useState("");
  const [searchDiscount, setsearchDiscount] = useState("");
  const [searchPostCode, setsearchPostCode] = useState("");

  useEffect(() => {
    if (localStorage.getItem("Team") === "PD") {
      setSearchPD(localStorage.getItem("Username"));
    }
  }, []);

  const handleSearchName = (event) => {
    setSearchName(event.target.value);
  };
  const handleSearchCountry = (event) => {
    setSearchCountry(event.target.value);
  };
  const handleSearchPD = (event) => {
    setSearchPD(event.target.value);
  };
  const handleSearchPS = (event) => {
    setsearchPS(event.target.value);
  };
  const handleSearchPostCode = (event) => {
    setsearchPostCode(event.target.value);
  };

  const handleSearchLimit = (event) => {
    setSearchLimit(event.target.value);
  };

  const handleSearchCharity = (event) => {
    setsearchCharity(event.target.value);
  };

  const handleSearchDiscount = (event) => {
    setsearchDiscount(event.target.value);
  };

  function handleSubmit(e) {
    e.preventDefault();
    Get_Schools_Fuzzy_Search(
      "Schools",
      "All_Schools",
      {
        searchName: searchName,
        searchCountry: searchCountry,
        searchPD: searchPD,
        searchPS: searchPS,
        searchCharity: searchCharity,
        searchDiscount: searchDiscount,
        searchPostCode: searchPostCode,
        limit: Number(searchLimit),
      },
      setSchools,
      logout
    );
  }

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "45%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Search Bar
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Change to row to align items in a line
          flexWrap: "wrap",
          alignItems: "center", // Align items vertically
          gap: "5px",
          color: "black",
          padding: "5px",
        }}
      >
        <TextField
          id="search_name"
          label="Name"
          variant="outlined"
          value={searchName}
          onChange={handleSearchName}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <TextField
          id="search_country"
          label="Country"
          variant="outlined"
          value={searchCountry}
          onChange={handleSearchCountry}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <TextField
          id="search_postcode"
          label="PostCode"
          variant="outlined"
          value={searchPostCode}
          onChange={handleSearchPostCode}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <TextField
          id="search_PD"
          label="PD"
          variant="outlined"
          value={searchPD}
          onChange={handleSearchPD}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <TextField
          id="search_PS"
          label="PS"
          variant="outlined"
          value={searchPS}
          onChange={handleSearchPS}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
          select
        >
          <MenuItem value=""></MenuItem>
          <MenuItem value="">No</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
        </TextField>
        <TextField
          id="search_Limit"
          label="Limit"
          variant="outlined"
          value={searchLimit}
          onChange={handleSearchLimit}
          type="number"
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <TextField
          id="search_charity"
          label="Charity"
          variant="outlined"
          value={searchCharity}
          onChange={handleSearchCharity}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
          select
        >
          <MenuItem value="">---</MenuItem>
          <MenuItem value="No">No</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
        </TextField>
        <TextField
          id="search_discount"
          label="Discount"
          variant="outlined"
          value={searchDiscount}
          onChange={handleSearchDiscount}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ flex: "none" }}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Search
        </Button>
      </Box>
    </Box>
  );
}

export default SearchBar;
